import React from "react";

export const DURATION_OPTIONS = [
  { value: "8h", labelKey: "last8Hours" },
  { value: "24h", labelKey: "last24Hours" },
  { value: "7d", labelKey: "last7Days" },
  { value: "30d", labelKey: "last30Days" },
];

export const durationLabel = (value, strings) => {
  const match = DURATION_OPTIONS.find((option) => option.value === value);
  return (match && strings?.[match.labelKey]) || value;
};

const NmsDurationMenu = ({ value, onChange, localizationStrings }) => (
  <div className="dropdown">
    <span className="dropdown" data-bs-toggle="dropdown" aria-expanded="false">
      {durationLabel(value, localizationStrings)}
      <i className="fa fa-angle-down" aria-hidden="true"></i>
    </span>
    <ul className="dropdown-menu dropdown-menu-end">
      {DURATION_OPTIONS.map((option) => (
        <li key={option.value}>
          <button
            type="button"
            className="dropdown-item"
            onClick={() => onChange(option.value)}
          >
            {localizationStrings?.[option.labelKey] || option.value}
          </button>
        </li>
      ))}
    </ul>
  </div>
);

export default NmsDurationMenu;
